import React from 'react';
import './Message.css';
import Text from '../Text';
import { Close as CloseIcon } from '../Icons';

const Message = ({ text, visible, onCloseBtnTap }) => (
    <div className={`message ${visible ? 'message--visible' : ''}`}>
        <p className="message__text">
            <Text>{text}</Text>
        </p>
        <button
            className="message__close-btn"
            onClick={onCloseBtnTap}
        >
            <CloseIcon />
        </button>
    </div>
);

export default Message;



// WEBPACK FOOTER //
// ./src/message/Message.js